import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "value", "error", "formControlLabelProps"];
import { FormHelperText } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
export var FormCheckbox = function (props) {
    var label = props.label, value = props.value, error = props.error, _a = props.formControlLabelProps, formControlLabelProps = _a === void 0 ? {} : _a, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(FormControl, {
        error: Boolean(error),
        color: error ? 'error' : 'info'
    }, /*#__PURE__*/ React.createElement(FormControlLabel, _extends({
        label: label,
        control: /*#__PURE__*/ React.createElement(Checkbox, _extends({
            checked: Boolean(value),
            size: "small",
            color: "info"
        }, others))
    }, formControlLabelProps)), error && /*#__PURE__*/ React.createElement(FormHelperText, null, error));
};
